class State {
  language = $state(import.meta.env.PUBLIC_DEFAULT_LANGUAGE)

  currency = $state(import.meta.env.PUBLIC_DEFAULT_CURRENCY)

  geolocation = $state(
    typeof window !== 'undefined' && 'GEOLOCATION' in window
      ? /** @type {App.Geolocation} */ (window.GEOLOCATION)
      : {}
  )

  prefix = $derived(this.prefixForLanguage(this.language))

  prefixForLanguage(language, defaultLanguage) {
    defaultLanguage = defaultLanguage ?? import.meta.env.PUBLIC_DEFAULT_LANGUAGE
    return language == null || language === defaultLanguage
      ? ''
      : `/${language}`
  }
}

export default new State()
